import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccessMatrixComponent } from './admin/access-matrix.component';
import { BatchExportComponent } from './admin/batch-export.component';
import { ExportQueueComponent } from './admin/export-queue.component';
import { TargetedEditComponent } from './admin/targeted-edit.component';
import { UserAdminComponent } from './admin/user-admin.component';
import { WorkflowAddComponent } from './admin/workflow-add/workflow-add.component';
import { WorkflowAdminComponent } from './admin/workflow-admin.component';
import { AppErrorComponent } from './app-error.component';
import { MasterCalcComponent } from './calculations/master-calc.component';
import { HomeComponent } from './ledgers/home.component';
import { LedgerComponent } from './ledgers/ledger.component';
import { LedgerGuard } from './ledgers/ledger.guard';
import { RequestAccessFormComponent } from './ledgers/request-access-form/request-access-form.component';
import { ReportsComponent } from './reports/reports.component';
import { MsalGuard } from '@azure/msal-angular';
import { FinancialPlanningMaintenanceMenuComponent } from './admin/maintenance/financial-planning-maintenance-menu.component';
import { ApplicationViewsUpsertComponent } from './admin/maintenance/ApplicationViews/application-views-upsert.component';
import { PositionTypesUpsertComponent } from './admin/maintenance/positionTypes/position-types/position-types-upsert.component';
import { OrganizationUpsertComponent } from './admin/maintenance/organizations/organization-upsert/organization-upsert.component';
import { AccountSplitUpsertComponent } from './admin/maintenance/management-fee-splits/account-splits-upsert/account-split-upsert.component';
import { ManagementFeeAccountSplitsListComponent } from './admin/maintenance/management-fee-splits/management-fee-account-splits-list/management-fee-account-splits-list.component';
import { LedgerViewInfoUpsertComponent } from './admin/maintenance/ledger-views/ledger-view-info-upsert/ledger-view-info-upsert.component';
import { ViewAccountsComponent } from './admin/maintenance/ledger-views/view-accounts/view-accounts.component';
import { GenericCanDeactivateGuard } from './shared/tcc-ui/generic-can-deactivate.guard';
import { OrgMappingLookupUpsertComponent } from './admin/maintenance/org-mapping-lookup/org-mapping-lookup-upsert/org-mapping-lookup-upsert.component';


const routes: Routes = [
  { path: 'error', component: AppErrorComponent, canActivate: [MsalGuard] },
  { path: 'home', 
    component: HomeComponent, 
    canActivate: [MsalGuard],
    children: [
      {
        path: 'requestaccessroles',
        component: RequestAccessFormComponent,
        canActivate: [MsalGuard]
      },
    ],
  },
  {
    path: 'ledger',
    component: LedgerComponent,
    canActivate: [MsalGuard, LedgerGuard],
    canDeactivate: [GenericCanDeactivateGuard],
    data: { 'hideNavOptions': true }
  },
  { path: 'masterCalc', component: MasterCalcComponent, canActivate: [MsalGuard] },
  { path: 'reports', component: ReportsComponent, canActivate: [MsalGuard] },
  {
    path: 'revenue',
    loadChildren: () => import('./revenue/revenue.module').then(m => m.RevenueModule),
    canActivate: [MsalGuard]
  },
  {
    path: 'accessMatrix',
    component: AccessMatrixComponent,
    children: [
      {
        path: 'useradmin',
        component: UserAdminComponent
      }
    ],
    canActivate: [MsalGuard]
  },
  {
    path: 'batchExport',
    component: BatchExportComponent,
    children: [
      {
        path: 'exportQueue',
        component: ExportQueueComponent
      }
    ],
    canActivate: [MsalGuard]
  },
  {
    path: 'workflowAdmin',
    component: WorkflowAdminComponent,
    canActivate: [MsalGuard],
    children: [
      { path: 'workflowAdd', component: WorkflowAddComponent, canActivate: [MsalGuard] }
    ]
  },
  {
    path: 'maintenance',
    component: FinancialPlanningMaintenanceMenuComponent,
    canActivate: [MsalGuard],
    children: [     
      {
        path: 'upsert-application-view/:id',
        component: ApplicationViewsUpsertComponent,
        canActivate: [MsalGuard]
      },
      {
        path: 'upsert-management-fee-split/:id',
        component: AccountSplitUpsertComponent,
        canActivate: [MsalGuard]
      },
      {
        path: 'upsert-organization/:orgId',
        component: OrganizationUpsertComponent,
        canActivate: [MsalGuard]
      },
      {
        path: 'upsert-org-mapping-lookup/:id',
        component: OrgMappingLookupUpsertComponent,
        canActivate: [MsalGuard]
      },
      {
        path: 'app-position-types-upsert/:id',
        component: PositionTypesUpsertComponent,
        canActivate: [MsalGuard]
      },
      {
        path: 'mgnt-fees-account-splits-list',
        component: ManagementFeeAccountSplitsListComponent,
        canActivate: [MsalGuard]
      },      
      {
        path: 'viewaccounts/:view',
        component: ViewAccountsComponent,
        canActivate: [MsalGuard],
      },      
      {
        path: 'upsert-view-info/:id',
        component: LedgerViewInfoUpsertComponent,
        canActivate: [MsalGuard]
      }
    ]
  },
  {
    path: 'targetedEdit',
    component: TargetedEditComponent,
    canActivate: [MsalGuard]
  },
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: '**', redirectTo: ' /home' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    anchorScrolling: 'enabled',
    enableTracing: false,
    onSameUrlNavigation: 'reload',
    paramsInheritanceStrategy: 'always',
    scrollPositionRestoration: 'enabled'
})],
  exports: [RouterModule],
})
export class AppRoutingModule { }

